import React from 'react';

const About = () => {
  return (
    <div name='about' className='w-full bg-[#0a192f] text-gray-300'>
      <div className='flex flex-col justify-center items-center w-full h-full'>
        <div className='max-w-[1000px] w-full grid grid-cols-2 gap-8'>
          <div className='sm:text-right pb-8 pl-4'>
            <p className='text-4xl font-bold inline border-b-4 border-pink-600'>
              About
            </p>
          </div>
          <div></div>
          </div>
          <div className='max-w-[1000px] w-full grid sm:grid-cols-2 gap-8 px-4'>
            <div className='sm:text-right text-4xl font-bold'>
              <p>Hi. I'm Mahbub E Waduzzaman, nice to meet you. Please explore my page:</p>
            </div>
            <div>
              <p>I have a strong passion for creating high-quality software that improves the lives 
                of individuals and businesses alike. I specialize in developing software applications 
                for a diverse range of clients, including individual users, small businesses, and large 
                corporations. Just imagine the opportunities that could arise from having a skilled software 
                specialist at your disposal.?</p>  
            </div>
          </div>
      </div>
    </div>
  );
};

export default About;